import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withCookies } from 'react-cookie'

import { withStyles } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import Drawer from '@material-ui/core/Drawer'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import List from '@material-ui/core/List'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import ExitToApp from '@material-ui/icons/ExitToApp'
import SvgIcon from '@material-ui/core/SvgIcon'
import Hidden from '@material-ui/core/Hidden'
import Switch from '@material-ui/core/Switch'
import Tooltip from '@material-ui/core/Tooltip'

import MainListItems from './listItems'
import Router from '../../router'
import Clock from '../Common/Clock'

const drawerWidth = 240

const OnLightIcon = props => (
  <SvgIcon {...props}>
    {
      <svg fill="#FFFFFF">
        <path d="m9,21c0,0.55 0.45,1 1,1l4,0c0.55,0 1,-0.45 1,-1l0,-1l-6,0l0,1zm3,-19c-3.86,0 -7,3.14 -7,7c0,2.38 1.19,4.47 3,5.74l0,2.26c0,0.55 0.45,1 1,1l6,0c0.55,0 1,-0.45 1,-1l0,-2.26c1.81,-1.27 3,-3.36 3,-5.74c0,-3.86 -3.14,-7 -7,-7z"></path>
      </svg>
    }
  </SvgIcon>
)

const OffLightIcon = props => (
  <SvgIcon {...props}>
    {
      <svg fill="#FFFFFF">
        <path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z"></path>
      </svg>
    }
  </SvgIcon>
)

const styles = theme => ({
  root: {
    display: 'flex'
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    minHeight: '20px'
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    backgroundColor: '#263238',
    minHeight: '0px'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    backgroundColor: '#ef9a9a' // '#e57373' for UAT, #263238 for DEV
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 12,
    color: 'white'
  },
  menuButtonHidden: {
    display: 'none'
  },
  title: {
    flexGrow: 1,
    color: 'white'
  },
  name: {
    color: 'white'
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    border: '1px'
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9
    }
  },
  appBarSpacer: {
    minHeight: '48px'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto'
  },
  flex: {
    flex: 1
  }
})

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      menuOpen: false,
      anchorEl: null,
      menuOpen_Message: false,
      anchorEl_Message: null,
      menuOpen_Mail: false,
      anchorEl_Mail: null,
      checkedGameTheme:
        props.cookies.get('checkedGameTheme') === 'true'
          ? true
          : false || false,
      checkedDarkTheme:
        props.cookies.get('checkedDarkTheme') === 'true' ? true : false || false
    }
  }

  handleDrawerOpen = () => {
    this.setState({ open: true })
  }

  handleDrawerClose = () => {
    this.setState({ open: false })
  }

  handleMenu = (event, param) => {
    switch (param) {
      case 'mail':
        this.setState({
          anchorEl_Mail: event.currentTarget,
          menuOpen_Mail: Boolean(event.currentTarget)
        })
        break
      case 'message':
        this.setState({
          anchorEl_Message: event.currentTarget,
          menuOpen_Message: Boolean(event.currentTarget)
        })
        break
      case 'alert':
        this.setState({
          anchorEl: event.currentTarget,
          menuOpen: Boolean(event.currentTarget)
        })
        break
      default:
    }
  }

  handleClose = () => {
    this.setState({
      menuOpen: false,
      menuOpen_Message: false,
      menuOpen_Mail: false
    })
  }

  handleSignoutClick = () => {
    this.props.handleSignoutClick()
  }

  handleChange = name => event => {
    const { cookies } = this.props

    if (name === 'checkedGameTheme') {
      if (event.target.checked) {
        cookies.set('checkedGameTheme', true)
      } else {
        cookies.set('checkedGameTheme', false)
      }
    }

    this.setState({
      [name]: event.target.checked
    })
  }

  handleToggleTheme = () => {
    this.props.cookies.set('checkedDarkTheme', !this.state.checkedDarkTheme)
    this.setState({
      checkedDarkTheme: !this.state.checkedDarkTheme
    })
  }

  render() {
    const { classes } = this.props

    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classes.root}>
          <AppBar
            position="absolute"
            className={classNames(
              classes.appBar,
              this.state.open && classes.appBarShift
            )}>
            <Toolbar
              disableGutters={!this.state.open}
              className={classes.toolbar}>
              <IconButton
                aria-label="Open drawer"
                onClick={this.handleDrawerOpen}
                className={classNames(
                  classes.menuButton,
                  this.state.open && classes.menuButtonHidden
                )}>
                <MenuIcon />
              </IconButton>
              <img
                src={require('../../images/cloudRiches_logo_white.png')}
                style={{ height: '30px', paddingRight: '30px' }}
                alt="cloudRiches_logo_white"
              />

              <Hidden smDown>
                <Typography
                  variant="subtitle1"
                  noWrap
                  className={classes.title}>
                  CloudRiches x Hunter Game
                </Typography>
              </Hidden>

              <Typography className={classes.flex} />
              <Hidden smDown>
                <Typography variant="caption" noWrap className={classes.name}>
                  <Clock
                    type="datetime"
                    loginDateTime={this.props.user.loginDateTime}
                  />
                </Typography>
              </Hidden>

              <Typography
                variant="caption"
                style={{ marginLeft: '10px' }}
                className={classes.name}
                noWrap>
                {this.props.user.id} - {this.props.user.username}
              </Typography>

              <Tooltip title="toggle Game Theme" placement="bottom">
                <Switch
                  color="default"
                  checked={this.state.checkedGameTheme}
                  onChange={this.handleChange('checkedGameTheme')}
                />
              </Tooltip>

              <IconButton onClick={this.handleToggleTheme}>
                {this.state.checkedDarkTheme ? (
                  <OffLightIcon />
                ) : (
                  <OnLightIcon />
                )}
              </IconButton>

              <Tooltip title="logout" placement="bottom">
                <IconButton onClick={e => this.handleSignoutClick(e)}>
                  <ExitToApp style={{ color: 'white' }} />
                </IconButton>
              </Tooltip>
            </Toolbar>
          </AppBar>
          <Drawer
            variant="permanent"
            classes={{
              paper: classNames(
                classes.drawerPaper,
                !this.state.open && classes.drawerPaperClose
              )
            }}
            open={this.state.open}>
            <div className={classes.toolbarIcon}>
              <IconButton onClick={this.handleDrawerClose}>
                <SvgIcon>
                  <path
                    d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
                    fill="white"
                  />
                </SvgIcon>
              </IconButton>
            </div>
            <Divider />
            <List>
              <MainListItems />
            </List>
          </Drawer>
          <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Router />
          </main>
        </div>
      </React.Fragment>
    )
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(withCookies(App))



// WEBPACK FOOTER //
// ./src/components/Homepage/App.js